import { getItem, setItem } from '../utils/localStorage';

const idb = window.indexedDB;
const updateHotelList = (selectedHotel) => {
  try {
    const hotelList = getItem('hotelList');
    if (hotelList && !hotelList.find((o) => o === selectedHotel)) {
      hotelList.push(selectedHotel);
      setItem('hotelList', JSON.stringify(hotelList));
    } else if (!hotelList) {
      hotelList.push(selectedHotel);
      setItem('hotelList', JSON.stringify(hotelList));
    }
  } catch (err) {}
};

export const CreateDataByIndexedDB = (apipath, data, selectedHotel) => {
  // open or create database
  updateHotelList(selectedHotel);
  const request = idb.open(selectedHotel);

  // catches error if there is any
  request.onerror = (e) => {};

  // Scheme of database
  request.onupgradeneeded = () => {
    const db = request.result;
    if (!db.objectStoreNames.contains('Apidata')) {
      db.createObjectStore('Apidata', { keyPath: 'id' });
    }
  };
  // Insert Data
  request.onsuccess = () => {
    const db = request.result;
    const tx = db.transaction('Apidata', 'readwrite');
    const store = tx.objectStore('Apidata');
    store.put({
      id: apipath,
      data,
    });
    tx.oncomplete = () => {
      db.close();
    };
  };
};
export const GetAllDataByIndexedDB = (apipath, selectedHotel) => {
  return new Promise((resolve, reject) => {
    // code
    updateHotelList(selectedHotel);
    const request = idb.open(selectedHotel);
    // catches error if there is any
    request.onerror = (e) => {};

    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains('Apidata')) {
        db.createObjectStore('Apidata', { keyPath: 'id' });
      }
    };

    request.onsuccess = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains('Apidata')) {
        resolve(false);
      } else {
        const tx = db.transaction('Apidata', 'readonly');
        const store = tx.objectStore('Apidata');
        const idQuery = store.get(apipath);
        idQuery.onsuccess = () => {
          idQuery.result ? resolve(idQuery.result.data) : resolve(false);
        };
        tx.oncomplete = () => {
          db.close();
        };
      }
    };
  });
};

export const deleteDatabase = (selectedHotel) => {
  return idb.deleteDatabase(selectedHotel);
};

export const ClearAllIndexedDB = () => {
  const hotelList = getItem('hotelList');
  if (hotelList) {
    hotelList.map((hotel) => idb.deleteDatabase(hotel));
  }
};
